"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InventoryManager = void 0;
class InventoryManager {
    constructor(gameSession) {
        this.gameSession = gameSession;
    }
    hasItem(ownerId, ownerType, itemTag) {
        const inventory = this.getInventory(ownerId, ownerType);
        return inventory.includes(itemTag);
    }
    addItem(ownerId, ownerType, itemTag) {
        if (ownerType === 'character') {
            const player = this.gameSession.players.find(p => p.id === ownerId);
            if (!player) {
                throw new Error(`Cannot add item '${itemTag}' to character '${ownerId}': player not found`);
            }
            if (!player.inventory.includes(itemTag)) {
                player.inventory.push(itemTag);
            }
        }
        else if (ownerType === 'location') {
            // Check if location inventory exists
            if (!this.gameSession.locationInventories.has(ownerId)) {
                throw new Error(`Cannot add item '${itemTag}' to location '${ownerId}': location inventory not found`);
            }
            const inventory = this.gameSession.locationInventories.get(ownerId);
            if (!inventory.includes(itemTag)) {
                inventory.push(itemTag);
            }
        }
    }
    removeItem(ownerId, ownerType, itemTag) {
        if (ownerType === 'character') {
            const player = this.gameSession.players.find(p => p.id === ownerId);
            if (!player) {
                throw new Error(`Cannot remove item '${itemTag}' from character '${ownerId}': player not found`);
            }
            const index = player.inventory.indexOf(itemTag);
            if (index > -1) {
                player.inventory.splice(index, 1);
            }
        }
        else if (ownerType === 'location') {
            // Access the map directly since the interface doesn't expose methods
            const locationInventory = this.gameSession.locationInventories.get(ownerId);
            if (!locationInventory) {
                throw new Error(`Cannot remove item '${itemTag}' from location '${ownerId}': location inventory not found`);
            }
            const index = locationInventory.indexOf(itemTag);
            if (index > -1) {
                locationInventory.splice(index, 1);
            }
        }
    }
    getInventory(ownerId, ownerType) {
        if (ownerType === 'character') {
            const player = this.gameSession.players.find(p => p.id === ownerId);
            return player ? [...player.inventory] : [];
        }
        else if (ownerType === 'location') {
            const locationInventory = this.gameSession.locationInventories.get(ownerId);
            return locationInventory ? [...locationInventory] : [];
        }
        return [];
    }
    getPlayerInventory(playerId) {
        return this.getInventory(playerId, 'character');
    }
    getLocationInventory(locationTag) {
        return this.getInventory(locationTag, 'location');
    }
    hasPlayerItem(playerId, itemTag) {
        return this.hasItem(playerId, 'character', itemTag);
    }
    hasLocationItem(locationTag, itemTag) {
        return this.hasItem(locationTag, 'location', itemTag);
    }
    addPlayerItem(playerId, itemTag) {
        this.addItem(playerId, 'character', itemTag);
    }
    addLocationItem(locationTag, itemTag) {
        this.addItem(locationTag, 'location', itemTag);
    }
    removePlayerItem(playerId, itemTag) {
        this.removeItem(playerId, 'character', itemTag);
    }
    removeLocationItem(locationTag, itemTag) {
        this.removeItem(locationTag, 'location', itemTag);
    }
}
exports.InventoryManager = InventoryManager;
//# sourceMappingURL=InventoryManager.js.map